export const DUMMY_CART_ENTRY_NAMES = [
  'combo sides',
  'combo item',
  'combo meals',
  'mix n match',
  "mix n' match",
];

export const isDummyItemName = (name?: string | null): boolean => {
  return DUMMY_CART_ENTRY_NAMES.includes(name?.toLowerCase().trim() ?? '');
};

export const isDummyItem = (item: { name: string } | string): boolean => {
  const name = typeof item === 'string' ? item : item?.name;
  return isDummyItemName(name);
};
